import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  cashThreshold: "Cash threshold",
  editThreshold: "Edit the cash threshold",
  thresholdInvalid: "Enter an amount from 0 upwards.",
  saveFailed: "Couldn't save the change.",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    cashThreshold: "Seuil de liquidités",
    editThreshold: "Modifier le seuil de liquidités",
    thresholdInvalid: "Saisissez un montant supérieur ou égal à 0.",
    saveFailed: "Impossible d'enregistrer la modification.",
  },
  es_ES: {
    cashThreshold: "Umbral de efectivo",
    editThreshold: "Editar el umbral de efectivo",
    thresholdInvalid: "Introduce un importe igual o superior a 0.",
    saveFailed: "No se pudo guardar el cambio.",
  },
  pt_BR: {
    cashThreshold: "Limite de caixa",
    editThreshold: "Editar o limite de caixa",
    thresholdInvalid: "Informe um valor a partir de 0.",
    saveFailed: "Não foi possível salvar a alteração.",
  },
  de_DE: {
    cashThreshold: "Liquiditätsschwelle",
    editThreshold: "Liquiditätsschwelle bearbeiten",
    thresholdInvalid: "Geben Sie einen Betrag ab 0 ein.",
    saveFailed: "Die Änderung konnte nicht gespeichert werden.",
  },
  it_IT: {
    cashThreshold: "Soglia di liquidità",
    editThreshold: "Modifica la soglia di liquidità",
    thresholdInvalid: "Inserisci un importo pari o superiore a 0.",
    saveFailed: "Impossibile salvare la modifica.",
  },
  ar: {
    cashThreshold: "حد النقد",
    editThreshold: "تعديل حد النقد",
    thresholdInvalid: "أدخل مبلغًا من 0 فأكثر.",
    saveFailed: "تعذّر حفظ التغيير.",
  },
  ja_JP: {
    cashThreshold: "現金のしきい値",
    editThreshold: "現金のしきい値を編集",
    thresholdInvalid: "0 以上の金額を入力してください。",
    saveFailed: "変更を保存できませんでした。",
  },
  hi_IN: {
    cashThreshold: "नकद सीमा",
    editThreshold: "नकद सीमा संपादित करें",
    thresholdInvalid: "0 या उससे अधिक राशि दर्ज करें।",
    saveFailed: "बदलाव सहेजा नहीं जा सका।",
  },
  zh_CN: {
    cashThreshold: "现金阈值",
    editThreshold: "编辑现金阈值",
    thresholdInvalid: "请输入大于或等于 0 的金额。",
    saveFailed: "无法保存更改。",
  },
  zh_TW: {
    cashThreshold: "現金門檻",
    editThreshold: "編輯現金門檻",
    thresholdInvalid: "請輸入大於或等於 0 的金額。",
    saveFailed: "無法儲存變更。",
  },
  nl_NL: {
    cashThreshold: "Liquiditeitsdrempel",
    editThreshold: "Liquiditeitsdrempel bewerken",
    thresholdInvalid: "Voer een bedrag in van 0 of hoger.",
    saveFailed: "Kan de wijziging niet opslaan.",
  },
  nb_NO: {
    cashThreshold: "Kontantterskel",
    editThreshold: "Endre kontantterskelen",
    thresholdInvalid: "Skriv inn et beløp fra 0 og oppover.",
    saveFailed: "Kunne ikke lagre endringen.",
  },
  sv_SE: {
    cashThreshold: "Tröskelvärde för likvida medel",
    editThreshold: "Redigera tröskelvärdet för likvida medel",
    thresholdInvalid: "Ange ett belopp från 0 och uppåt.",
    saveFailed: "Det gick inte att spara ändringen.",
  },
  fi_FI: {
    cashThreshold: "Käteisen raja-arvo",
    editThreshold: "Muokkaa käteisen raja-arvoa",
    thresholdInvalid: "Anna summa, joka on vähintään 0.",
    saveFailed: "Muutosta ei voitu tallentaa.",
  },
  da_DK: {
    cashThreshold: "Kontantgrænse",
    editThreshold: "Rediger kontantgrænsen",
    thresholdInvalid: "Angiv et beløb fra 0 og opefter.",
    saveFailed: "Kunne ikke gemme ændringen.",
  },
  is_IS: {
    cashThreshold: "Viðmiðunarmörk reiðufjár",
    editThreshold: "Breyta viðmiðunarmörkum reiðufjár",
    thresholdInvalid: "Sláðu inn upphæð frá 0 og upp úr.",
    saveFailed: "Ekki tókst að vista breytinguna.",
  },
};
